import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import { na1 } from 'hubspot-url-utils/hublets';
import { registerQuery } from 'data-fetching-client';
/*
 * Endpoint to get the public ID of the most recent active quote.
 * Returns the public ID of the most recent active quote containing any of the specified products.
 * If no apiNames are provided, returns the most recent quote overall.
 * Requires AppAuth + billing-write scope.
 */
export const GET_ACTIVE_QUOTE_PUBLIC_ID = registerQuery({
  fieldName: 'activeQuotePublicId',
  args: ['apiNames'],
  fetcher({
    apiNames
  }) {
    const apiUrl = getFullUrl('app-api', {
      hubletOverride: na1
    });
    const hubId = PortalIdParser.get();
    const baseUrl = `${apiUrl}/quotes/v2/quotes/active-quote-public-id/hub/${hubId}`;
    const url = new URL(baseUrl);
    if (apiNames && apiNames.length > 0) {
      apiNames.forEach(name => url.searchParams.append('apiNames', name));
    }
    return http.get(url.toString());
  }
});